import React, { useMemo } from 'react'
import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import useServices from '../../../../Model/Services/List'
import FilterBadge from '../../../../common/FilterBadge'

const ServicesFilter = (props) => {
  const { serviceFilters, setServiceFilters, useInner = false } = props
  const { translate } = useTranslation()
  const { data: services, loading: servicesLoading } = useServices({ limit: 0 })
  const serviceData = useMemo(
    () => (services.docs || []).map(item => ({ name: item.name, id: item.id })).sort((a, b) => a.name.localeCompare(b.name)) 
  , [services])
  return (
    !servicesLoading && (
      useInner ? 
      <CheckboxSelectorInner
        style={{maxWidth: 'auto'}}
        setDataFilters={setServiceFilters}
        direction='bottom'
        dataFilters={serviceFilters}
        data={serviceData}
        typeFilter='services'
        strings={{
          viewAll: translate('filters.plans.viewAll'),
          buttonCancel: translate('filters.plans.buttonCancel'),
          buttonApply: translate('filters.plans.buttonApply'),
          search: translate('filters.plans.search')
        }}
      /> :
      <CheckboxSelector
        setDataFilters={setServiceFilters}
        direction='bottom'
        dataFilters={serviceFilters}
        data={serviceData}
        typeFilter='services'
        strings={{
          viewAll: translate('filters.plans.viewAll'),
          buttonCancel: translate('filters.plans.buttonCancel'),
          buttonApply: translate('filters.plans.buttonApply'),
          search: translate('filters.plans.search')
        }}
      >
        <FilterBadge
          title={translate('filters.plans.services.title')}
          options={serviceData}
          selectedIds={serviceFilters}
          onClearFilters={() => setServiceFilters([])}
          className='mr-1 filters'
        />
      </CheckboxSelector>
    )
  )
}
export default ServicesFilter
